import styled from 'styled-components'

export const LogoImg = styled.img`
  alt: logo;
  height: 32px;
  margin: 24px;
`
